<template>
    <div>
        <Card>
            <template #title>
                Log
            </template>
            <template #content>
                <Toolbar class="mb-2 bg-gray-100">
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-search" label="Buscar" severity="success" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="operacao" header="Operacao" sortable></Column>
                    <Column field="table" header="Tabela" sortable></Column>
                    <Column field="table_id" header="ID" sortable></Column>
                    <Column field="created_at" header="Data/Hora" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.created_at) }}
                        </template>
                    </Column>

                    <Column field="usuario" header="Usuário" sortable></Column>
                    <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <Button icon="pi pi-list" title="Ver Log" severity="info" size="small"
                                @click="openLogModal(data)" />
                        </template>
                    </Column>
                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>
        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">

                    <div class="w-full">
                        <br>
                        <ul class="list-none p-0 m-0 flex flex-col gap-4">
                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputNumber id="id" v-model="params.filter.id" class="w-full" />
                                    <label for="id">Id</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputText id="operacao" v-model="params.filter.operacao" class="w-full" />
                                    <label for="operacao">Operacao</label>
                                </FloatLabel>
                            </div>
                        </ul>

                        <ul class="list-none p-0 m-0 flex flex-col gap-4">

                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputNumber id="table_id" v-model="params.filter.table_id" class="w-full" />
                                    <label for="table_id">ID Tabela</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputText id="table" v-model="params.filter.table" class="w-full" />
                                    <label for="table">Table</label>
                                </FloatLabel>
                            </div>
                        </ul>

                        <ul class="list-none p-0 m-0 flex flex-col gap-4">
                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputText id="objeto" v-model="params.filter.objeto" class="w-full" />
                                    <label for="obejeto">Objeto</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1">
                                <FloatLabel>
                                    <InputText id="created_by" v-model="params.filter.created_by" class="w-full" />
                                    <label for="created_by">Usuário</label>
                                </FloatLabel>
                            </div>
                        </ul>

                        <ul class="list-none p-0 m-0 flex flex-col gap-4">
                            <li class="field mt-1">
                                <FloatLabel>
                                    <DatePicker id="created_at_inicio" v-model="params.filter.created_at_inicio"
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="created_at_inicio">Data Inicio</label>
                                </FloatLabel>
                            </li>
                            <li class="field mt-1">
                                <FloatLabel>
                                    <DatePicker id="created_at_fim" v-model="params.filter.created_at_fim"
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="created_at_fim">Data Fim</label>
                                </FloatLabel>
                            </li>

                        </ul>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>

        </Popover>

        <LogList :visible="visibleLogModal" @update:visible="visibleLogModal = $event"  :data="selectedLog" @close="visibleLogModal=false"/>

    </div>
</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DatePicker from 'primevue/datepicker';
import Dialog from 'primevue/dialog';
import Moment from 'moment';

import Log from '@/service/log.js';

import Filter from '@/utils/Filter.js';

import LogList from './LogList.vue';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        Dialog,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        InputNumber,
        DatePicker,

        LogList,

    },
    data() {
        return {
            permissoes: permissoes,
            lista: [],
            isLoading: false,
            item: {},
            visibleForm: false,

            visibleLogModal: false,
            selectedLog: null,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: -1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    beforeMount() {
        this.pagination.page = parseInt(this.$route.query.page || 0);
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadData();
    },
    methods: {
        dateFormat(value) {
            if (!value) return;
            return Moment.utc(value).local().format("DD/MM/YYYY HH:mm");
        },
        parseContentLog(content) {
            try {
                return JSON.parse(content);
            } catch (error) {
                return {};
            }
        },
        openLogModal(log) {
            this.selectedLog = log;
            this.visibleLogModal = true;
        },

        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Log.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);
            
            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Log.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
